export const supplementOptimizerService = async (supplementList, setButtonText, setButtonDisabled) => {
    const token = localStorage.getItem("authToken"); 

    if (!token) {
        throw new Error("No auth token found");
    }

    const supplementInput = {
        supplementList,
    };
    console.log("supplement List", supplementList);

    setButtonText("Optimizing...");
    setButtonDisabled(true);

    try {
        const response = await fetch(`/api/v1/supplement-optimizer`, { 
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(supplementInput),
        });

        if (!response.ok) {
            throw new Error(`API Error: ${response.statusText}`);
        }
        
        const apiResponse = await response.json();
        console.log("optimize response", apiResponse);
        
        setButtonText("Optimization Complete!");
        return apiResponse; 


    } catch (error) {
        setButtonText("Error Checking");
    } finally {
        setButtonDisabled(false);
    }
};
